import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomPaginatorService extends MatPaginatorIntl {
  constructor(private translate: TranslateService) {
    super();
    this.translate.onLangChange.subscribe(() => this.getAndInitTranslations());
    this.getAndInitTranslations();
  }

  getAndInitTranslations() {
    this.itemsPerPageLabel = this.translate.instant('pagination.itemsPerPage');
    this.nextPageLabel = this.translate.instant('pagination.nextPage');
    this.previousPageLabel = this.translate.instant('pagination.previousPage');
    this.firstPageLabel = this.translate.instant('pagination.firstPage');
    this.lastPageLabel = this.translate.instant('pagination.lastPage');
    this.changes.next();
  }

  override getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    if (length === 0 || pageSize === 0)
      return this.translate.instant('pagination.rangeLabelEmpty', { length });

    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;

    return this.translate.instant('pagination.rangeLabel', {
      start: startIndex + 1,
      end: endIndex,
      total: length,
    });
  };
}
